import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const expertiseAreas = [
  {
    title: "Smart Elevator Systems",
    description: "Advanced vertical transportation systems designed for safety, efficiency, and seamless mobility within modern buildings.",
    icon: "ArrowUp",
    tags: ["Safety", "Efficiency", "Seamless"]
  },
  {
    title: "HVAC Engineering",
    description: "High-performance climate control systems designed to maintain optimal indoor environments while improving energy efficiency.",
    icon: "Wind",
    tags: ["High-Performance", "Climate Control", "Efficiency"]
  },
  {
    title: "Intelligent Building Technologies",
    description: "Integrated automation systems that monitor, manage, and optimize building operations for greater efficiency and reliability.",
    icon: "Zap",
    tags: ["Automation", "Optimization", "Reliability"]
  }
];

const ExpertiseSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mb-20">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8"
          >
            Our Expertise
          </motion.h2>
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold text-[#4D4C4A] leading-[1.1] italic tracking-tighter"
          >
            Specialized Engineering Services <br />
            Supporting Modern Infrastructure.
          </motion.h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {expertiseAreas.map((area, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              className="p-10 border border-slate-100 bg-slate-50 hover:bg-white hover:shadow-2xl transition-all duration-500 group"
            >
              <div className="w-14 h-14 bg-[#4D4C4A] flex items-center justify-center mb-10 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-6">
                <Icon name={area.icon} size={28} className="text-[#91756A]" />
              </div>
              <h4 className="text-xl font-bold text-[#4D4C4A] mb-6 italic tracking-tight uppercase group-hover:text-[#91756A] transition-colors duration-300">
                {area.title}
              </h4>
              <p className="text-slate-500 leading-relaxed mb-8">
                {area.description}
              </p>
              <div className="flex flex-wrap gap-2">
                {area.tags.map((tag, tagIndex) => (
                  <span key={tagIndex} className="text-[10px] font-bold uppercase tracking-widest text-slate-400 border border-slate-200 px-3 py-1">
                    {tag}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;